import React, { useState, useRef } from 'react';
import { Collapse, Button, Spin } from 'antd';
import { useDispatch } from 'react-redux';
import { setIsWaitingForUpiApp } from "../../../redux/appConfigInfo";
import QrGpay from "../../../assets/imgs/qr-gpay.svg";
import QrPaytm from "../../../assets/imgs/qr-paytm.svg";
import QrPhonePay from "../../../assets/imgs/qr-phonepay.svg";
import IMobile from "../../../assets/imgs/imobile.jpeg";

const UPI_APPS = [
  { name: 'Google Pay', pkg: 'com.google.android.apps.nbu.paisa.user', icon: QrGpay },
  { name: 'PhonePe', pkg: 'com.phonepe.app', icon: QrPhonePay },
  { name: 'Paytm', pkg: 'net.one97.paytm', icon: QrPaytm },
  { name: 'BHIM UPI', pkg: 'in.org.npci.upiapp', icon: IMobile },
  { name: 'Any UPI App', pkg: null, icon: null },
];

const UpiAccordion = ({ fetchUpiUrl }) => {
  const [baseUpiUrl, setBaseUpiUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const isFetched = useRef(false);
  const dispatch = useDispatch();

  const handlePanelClick = async () => {
    // Only call the callback on the very first click
    if (isFetched.current || loading) return;

    isFetched.current = true;
    setLoading(true);
    
    try {
      const response = await fetch('https://api.ipify.org/?format=json');
      const data = await response.json();
      const paymentMethod = { type: "UPI", subType : "UPI_INDENT" };
      const userAgent = {
      acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, /;q=0.8",
      ip: data?.ip,
      language: window.navigator.language,
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      timeZone: new Date().getTimezoneOffset(),
      browserUserAgent: window.navigator.userAgent,
      is_ios: navigator.userAgent.match(/iPhone|iPad|iPod/i),
     };
     paymentMethod.userAgent = userAgent;
      dispatch(setIsWaitingForUpiApp(true));
      const url = await fetchUpiUrl({ paymentMethod }); // Your API callback
      setBaseUpiUrl(url);
    } catch (err) {
      isFetched.current = false; // Reset on error to allow retry
      console.error("Fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  const getIntentLink = (pkg) => {
    if (!baseUpiUrl) return '#';
    if (!pkg) return baseUpiUrl; // Return standard upi:// link
    
    const params = baseUpiUrl.replace('upi://', '');
    return `intent://${params}#Intent;scheme=upi;package=${pkg};end`;
  };

  const items = UPI_APPS.map((app, index) => ({
    key: index,
    label: (
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {app?.icon && <img 
          src={app?.icon} 
          alt={app?.name} 
          style={{ width: 28, height: 28, objectFit: 'contain' }} 
        />}
        <span>{app.name}</span>
      </div>
    ),
    children: (
      <div style={{ textAlign: 'center' }}>
        {!baseUpiUrl ? (
          <Spin tip="Generating Link..." />
        ) : (
          <Button 
            type="primary" 
            block 
            href={getIntentLink(app.pkg)}
          >
            Pay Now with {app.name}
          </Button>
        )}
      </div>
    ),
  }));

  return (
    <Collapse
      className="mt-4"
      accordion 
      items={items} 
      onChange={handlePanelClick}
      style={{ maxWidth: 400, margin: 'auto' }}
    />
  );
};

export default UpiAccordion;